const IneligibleIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C7.59132 12 9.11741 11.3679 10.2426 10.2426C11.3679 9.11745 12 7.59127 12 6C12 4.40873 11.3679 2.88259 10.2426 1.75739C9.11745 0.632138 7.59127 0 6 0C4.40873 0 2.88259 0.632138 1.75739 1.75739C0.632138 2.88255 0 4.40873 0 6C0 7.59127 0.632138 9.11741 1.75739 10.2426C2.88255 11.3679 4.40873 12 6 12ZM6.12751 4.69458L3.71654 2.30206L2.30777 3.7217L4.71342 6.10893L2.30233 8.53862L3.72197 9.94739L6.12792 7.52288L8.4177 9.83163L9.83773 8.42326L7.54202 6.10853L9.8319 3.83746L8.42353 2.41742L6.12751 4.69458Z"
      fill="#B32722"
    />
  </svg>
);

export default IneligibleIcon;
